<section class="manual">
  <div class="manual-wrap">
    <h2
      class="manual-header"
      [innerHTML]="'SERVICE_MANUAL.TITLE' | translate"
    ></h2>
    <div class="manual-content">
      <div class="manual-description mb-4">
        <p class="manual-info">{{ 'SERVICE_MANUAL.TEXT1' | translate }}</p>
        <p class="manual-info">{{ 'SERVICE_MANUAL.TEXT2' | translate }}</p>
        <p class="manual-info">{{ 'SERVICE_MANUAL.TEXT3' | translate }}</p>
        <p class="manual-info">{{ 'SERVICE_MANUAL.TEXT4' | translate }}</p>
        <p class="manual-info">
          {{ 'SERVICE_MANUAL.TEXT5' | translate }}
          <a class="manual-link" (click)="redirect('about-us')">{{
            'SERVICE_MANUAL.BTN' | translate
          }}</a>
        </p>
      </div>
    </div>
  </div>
</section>
